import { Inject, Injectable } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { UploadAPIService } from 'src/app/extensions/services/api/upload-api.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { FileEvents } from 'src/app/extensions/services/api/events';
import { convertFileSize } from 'src/app/extensions/utilities';
import { FILE_UPLOAD_ERROR_CODE } from 'src/app/extensions/constants/commonConstants';
import { ENV_CONFIG } from 'src/app/core/injection.token';

@Injectable()
export class FilesHandler {
  UPLOAD_ALLOWED_EXTENSIONS = [
    ...this._envConfig.ALLOWED_FILE_EXTENSIONS.DOCUMENTS,
    ...this._envConfig.ALLOWED_FILE_EXTENSIONS.IMAGES,
  ];

  public constructor(
    @Inject(UploadAPIService) private _uploadAPIService: UploadAPIService,
    @Inject(NotificationService) private _notificationService: NotificationService,
    @Inject(TranslateService) private _translateService: TranslateService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvConfigurationData
  ) {}

  deleteFileHandler = (dataToSend: app.models.RequestXDocument[], file: app.models.RequestXDocument) => {
    var toDeleteFile = dataToSend.find(x => x.documentId == file.documentId);
    if (toDeleteFile) {
      var indexFile = dataToSend.indexOf(toDeleteFile);
      dataToSend.splice(indexFile, 1);
    }
  };

  fileUploadLoading: boolean = true;
  uploadFilesHandler = (dataToSend: app.models.RequestXDocument[], event: any) => {
    const file = event.target.files[0];

    const allowedFileSizeinBytes = this._envConfig.ALLOWED_FILE_SIZE * 1000000;
    if (file.size > allowedFileSizeinBytes) {
      this._notificationService.showWarning(
        this._translateService.instant('common.fileSizeExceeded', { maxSize: this._envConfig.ALLOWED_FILE_SIZE }),
        this._translateService.instant('common.warning')
      );
      event.target.value = '';
      return;
    }

    const fileExtension = file?.name.split('.').pop()?.toLowerCase();
    if (!fileExtension || !this.UPLOAD_ALLOWED_EXTENSIONS.includes(fileExtension)) {
      this._notificationService.showWarning(
        this._translateService.instant('common.uploadedFileWrongExtension'),
        this._translateService.instant('common.warning')
      );
      event.target.value = '';
      return;
    }

    var formData = new FormData();
    formData.append('Files', file, file.name);

    this._uploadAPIService
      .uploadFile(formData)
      .pipe(finalize(() => (this.fileUploadLoading = false)))
      .subscribe(result => {
        if (result.events.some(x => x.eventType == FileEvents.PortalFilePostFailed)) {
          const failedEvents = result.events.filter(x => x.eventType == FileEvents.PortalFilePostFailed);
          const eventCodes = failedEvents.map(e => e.eventBody.eventCode);

          let notification = '';

          if (eventCodes.includes(FILE_UPLOAD_ERROR_CODE.VIRUS)) {
            notification =
              failedEvents.length > 1 ? 'common.uploadedFilesContainsVirus' : 'common.uploadedFileContainsVirus';
          } else if (eventCodes.includes(FILE_UPLOAD_ERROR_CODE.INVALID_FILE_TYPE)) {
            notification =
              failedEvents.length > 1 ? 'common.uploadedFilesInvalidType' : 'common.uploadedFileInvalidType';
          }

          if (notification) {
            this._notificationService.showWarning(
              this._translateService.instant(notification),
              this._translateService.instant('common.warning')
            );
          }
          return;
        }
        const eventBodies = result.events.map(event => {
          const eventBody = event.eventBody;
          eventBody.convertedDocumentSize = convertFileSize(eventBody.documentSize);
          return eventBody;
        });
        dataToSend.push(...eventBodies);
      });

    event.target.value = '';
  };
}
